/* jshint esversion: 6 */
/* jshint ignore:start */
import { useState } from 'react';
import DefaultLogo from '../assets/Image/default_pic.png';
const ImageLoad = ({ src, alt, CustomeStyle, ImagStyle, status }) => {

    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);

    return <div className={`${CustomeStyle} relative`}>
        {!error && <img
            src={src}
            alt={alt}
            loading="lazy"
            onLoad={() => setLoaded(true)}
            onError={() => setError(true)}
            className={`${ImagStyle} transition-all duration-300 absolute top-0 ${loaded ? "opacity-100" : "opacity-0"}`}
        />}

        {!status && (error || !loaded) && <div className={`${CustomeStyle} shimmer absolute top-0 ${loaded ? "opacity-0" : "opacity-100"} transition-opacity duration-300`}></div>}
        {status && (error || !loaded) && <img
            src={DefaultLogo}
            alt={"DefaultLogo"}
            className={`${ImagStyle} absolute top-0`}
        />}
    </div>
};

export default ImageLoad;
/* jshint ignore:end */